"use client";

import { useEffect } from "react";
import "./App.css";
import { ThemeProvider } from "@material-tailwind/react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AppProvider } from "./Components/context/AppContext";
import { ApplicationStatusProvider } from "./Components/context/ApplicationStatusContext";
import ScrollToTop from "./Components/ScrollToTop";
import { routeConfig } from "./route-config";

function App() {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      localStorage.clear(); // Clear local storage
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <ThemeProvider>
      <ApplicationStatusProvider>
        <AppProvider>
          <div>
            <Router>
              <ScrollToTop />
              <Routes>
                {/* Map all routes from the route config */}
                {routeConfig.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      typeof route.component === "function" ? (
                        <route.component />
                      ) : (
                        route.component
                      )
                    }
                  />
                ))}

                {/* Add redirects for original paths to display paths */}
                {routeConfig
                  .filter(
                    (route) =>
                      route.originalPath && route.originalPath !== route.path
                  )
                  .map((route) => (
                    <Route
                      key={`redirect-${route.originalPath}`}
                      path={route.originalPath}
                      element={<Navigate to={route.path} replace />}
                    />
                  ))}

                {/* Catch-all route for 404 */}
                <Route path="*" element={<div>Page Not Found</div>} />
              </Routes>
            </Router>
          </div>
        </AppProvider>
      </ApplicationStatusProvider>
    </ThemeProvider>
  );
}

export default App;
